<template>
    <v-row justify="center">
        <v-dialog
            class="group-holiday-modal"
            v-model="dialog"
            persistent
            max-width="370">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ headerText }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.groupHolidayFormModal.groupHolidayName')"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :rules="inputRules"
                            :error-messages="errors.name">
                        </v-text-field>

                        <v-combobox
                            @change="groupSelect"
                            v-model="selectedGroups"
                            item-text="name_with_workday"
                            :prepend-item="'Select All'"
                            :items="groups"
                            :rules="groupInputRules"
                            :label="$vuetify.lang.t('$vuetify.groupHolidayFormModal.forGroup')"
                            placeholder=" "
                            multiple>
                            <template v-slot:prepend-item>
                                <v-list-item
                                    @click="selectAll()"
                                    ripple>
                                    <v-list-item-action>
                                        <v-checkbox
                                            v-model="selectedAll"
                                            @click="selectAll()">
                                        </v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-combobox>

                        <v-menu
                            v-model="datePickerShow"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :class="{ 'date-holiday': warning }"
                                    v-model="dateFormatted"
                                    :error-messages="errors.date"
                                    :label="$vuetify.lang.t('$vuetify.groupHolidayFormModal.holidayDate')"
                                    placeholder=" "
                                    append-icon="event"
                                    @click:append="datePickerShow = true"
                                    :rules="inputRules"
                                    :hint="warning"
                                    persistent-hint
                                    readonly
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                :locale="localeLang"
                                v-model="form.date"
                                :rules="inputRules"
                                @input="datePickerShow = false"
                                :min="min"
                                @change="errors.date = null">
                            </v-date-picker>
                        </v-menu>

                        <v-textarea
                            class="d-text-area"
                            :label="$vuetify.lang.t('$vuetify.groupHolidayFormModal.description')"
                            :maxlength="255"
                            v-model="form.description"
                            :rules="descriptionRules"
                            placeholder=" "
                            :error-messages="errors.description"
                            rows="2"
                            no-resize counter>
                        </v-textarea>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitGroupHoliday()">
                        {{ $vuetify.lang.t('$vuetify.groupHolidayFormModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'GroupHolidayFormModal',

    directives: {
        mask
    },

    props: {
        mode: {
            type: String,
            default: null
        },
        groupHolidayId: {
            type: Number,
            default: null
        },
        min: {
            type: String,
            default: null
        },
        branchId: {
            type: Number,
            default: null
        }
    },
    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        errorMsg () {
            return this.$vuetify.lang.t('$vuetify.groupHolidayFormModal.msgError')
        },
        inputRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.groupHolidayFormModal.msgRequiredField)
            ]
        },
        imputRulesName () {
            return [
                v => this.$validator.hasValue(v, this.trans.groupHolidayFormModal.msgRequiredField),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.groupHolidayFormModal.msgLimitCharacters)
            ]
        },
        groupInputRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.groupHolidayFormModal.msgRequiredField),
                v => this.$validator.arrayValueIn(v, this.groups, 'id', 'id', this.trans.groupHolidayFormModal.msgRequiredField)
            ]
        },
        descriptionRules () {
            return [
                v => this.$validator.lengthNotExceed(v, 255, this.trans.groupHolidayFormModal.msgLimitCharacters)
            ]
        },
        msgSaveSuccess () {
            let msg = this.trans.groupHolidayFormModal.msgCreateSuccess
            if (this.mode === 'update') {
                msg = this.trans.groupHolidayFormModal.msgUpdateSuccess
            }

            return {
                title: this.trans.groupHolidayFormModal.congratulation,
                text: msg,
                type: 'success'
            }
        },
        msgErrorStartTimeAndEndTime () {
            return this.trans.groupHolidayFormModal.msgErrorStartTimeAndEndTime
        },
        headerText () {
            if (this.mode === 'create') {
                return this.$vuetify.lang.t('$vuetify.groupHolidayFormModal.addGroupHoliday')
            } else {
                return this.$vuetify.lang.t('$vuetify.groupHolidayFormModal.editGroupHoliday')
            }
        }
    },
    data () {
        return {
            dialog: false,
            valid: true,
            datePickerShow: false,
            form: {
                name: null,
                date: '',
                description: '',
                groups: []
            },
            errors: [],
            dateFormatted: '',
            headModal: 'Warning Special Workday',
            titleModal: 'Do you want to create special workday on holiday ?',
            warning: null,
            groups: [],
            selectedGroups: [],
            selectedAll: false
        }
    },
    methods: {
        openModal () {
            this.dialog = true
        },

        closeModal () {
            this.$refs.form.resetValidation()
            this.dialog = false
            this.errors = []
            this.datePickerShow = false
            this.selectedGroups = []
            this.selectedAll = false
            this.clearForm()
            this.$emit('modal-closed')
        },

        clearForm () {
            this.form = {
                name: null,
                date: '',
                description: '',
                groups: []
            }
            this.warning = null
        },

        async getGroupHoliday (id) {
            const res = await this.axios.get(`group/holiday/${id}`)
            if (res && res.data && res.data.status === 'ok') {
                const responsData = res.data.data
                this.form.name = responsData.name
                this.form.date = responsData.date
                this.form.description = responsData.description
                this.selectedGroups = this.mapGroupDataFromGroupId(responsData.groups)
            }
        },

        mapGroupDataFromGroupId (groupIds) {
            const result = []
            for (let i = 0; i < groupIds.length; i++) {
                const foundGroup = this.groups.find(group => group.id === groupIds[i])
                result.push(foundGroup)
            }
            return result
        },

        async createGroupHoliday () {
            this.$store.dispatch('setLoading', true)
            this.form.groups = this.selectedGroups.map(group => group.id)
            const res = await this.axios.post('group/holiday/create', this.form)
            this.checkResponse(res, 'create')
        },

        async updateSpecialWorkday (groupHolidayId) {
            this.$store.dispatch('setLoading', true)
            this.form.groups = this.selectedGroups.map(group => group.id)
            const res = await this.axios.put(`group/holiday/edit/${this.groupHolidayId}`, this.form)
            this.checkResponse(res, 'edit')
        },

        checkResponse (res, type) {
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success')
                this.dialog = false
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify(this.msgSaveSuccess)
            }
        },

        async submitGroupHoliday () {
            if (!this.$refs.form.validate() || this.errors.date) {
                return
            }

            if (this.mode === 'create') {
                await this.createGroupHoliday()
            } else if (this.mode === 'update') {
                await this.updateSpecialWorkday()
            }
        },

        setDefaultHolidayToday () {
            const todayDate = new Date()
            todayDate.setDate(todayDate.getDate() + 1)

            this.form.date = todayDate.toISOString().substr(0, 10)
        },

        async getGroups () {
            this.groups = await this.$util.getGroups(this.branchId)
        },

        groupSelect (v) {
            if (this.groupInputRules[0](v) === true) {
                if ((this.groupInputRules[1](v) === true) && (v.length === this.groups.length)) {
                    this.selectedAll = true
                    return
                }
            }

            this.selectedAll = false
        },

        selectAll () {
            this.selectedGroups = []
            if (this.selectedAll) {
                this.selectedAll = false
            } else {
                this.selectedAll = true
                this.selectedGroups = [...this.groups]
            }
        }
    },

    mounted () {
        this.registerLang({
            groupHolidayFormModal: [
                'msgRequiredField',
                'msgLimitCharacters',
                'msgLimitCharacters',
                'msgCreateSuccess',
                'msgUpdateSuccess',
                'congratulation',
                'msgErrorStartTimeAndEndTime'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
                this.setDefaultHolidayToday()
                await this.getGroups()
            } else if (newValue === 'update') {
                await this.getGroups()
                await this.getGroupHoliday(this.groupHolidayId)
            }
        },

        'form.date' () {
            this.dateFormatted = this.$util.formatDate(this.form.date)
        },

        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.date-holiday {
    ::v-deep .v-messages__message {
        color: #f39c12;
        font-size: 14px;
    }
    ::v-deep .v-text-field__slot input {
        color: #f39c12;
    }
    ::v-deep .v-icon--link {
        color: #f39c12;
    }
    ::v-deep label {
        color: #f39c12;
    }
}
.group-holiday-modal {
    .theme--light, .v-divider {
        border-color: rgb(148 148 148);
    }
}
</style>
